var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOwnershipResponsibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4E88BF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665 2669c-9.155 0-17 8.601-17 15.643 0 .454.377.823.84.823h15.32v12.197c0 1.84 1.528 3.337 3.407 3.337 1.88 0 3.408-1.498 3.408-3.337 0-.454-.377-.824-.841-.824-.464 0-.84.37-.84.824 0 .933-.775 1.69-1.727 1.69-.952 0-1.726-.758-1.726-1.69v-12.197h15.318c.464 0 .841-.37.841-.823 0-7.042-7.845-15.643-17-15.643z",
    transform: "translate(-648 -2669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOwnershipResponsibility);
export default __webpack_public_path__ + "static/media/icon-ownership-responsibility.02aed4f0e0a7da099c3af80a8748c0ff.svg";
export { ForwardRef as ReactComponent };